import React, {useCallback, useState} from 'react';
import {createPortal} from 'react-dom';
import {ArrowsPointingOutIcon, ArrowTopRightOnSquareIcon} from '@heroicons/react/24/outline';
import {EditorPreview} from 'components';

interface IProjectURLProps {
  link: string;
  linkNav: string;
}

const ProjectURL = ({link, linkNav}: IProjectURLProps) => {
  const [preview, setPreview] = useState('');

  const handlePreview = async () => {
    // TODO: implement preview fullscreen
  };

  const handleClosePreview = useCallback(() => {
    setPreview('');
  }, [setPreview]);

  return (
    <div className="sticky top-0 z-10 flex justify-center items-center w-full py-3 px-5 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-darkBg">
      <a
        href={linkNav}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full max-w-sm flex gap-2 items-center justify-between bg-slate-200 dark:bg-slate-800 dark:text-slate-300 rounded-full px-4 py-0.5 text-sm/6 hover:brightness-105 dark:hover:brightness-120 cursor-pointer duration-200">
        <p className="truncate">{link}</p>
        <ArrowTopRightOnSquareIcon className="size-4 shrink-0" />
      </a>
      <button
        type="button"
        title="Preview"
        className="absolute right-0 border border-slate-300 rounded-md p-1 hover:bg-primary hover:text-white active:scale-90 cursor-pointer"
        onClick={handlePreview}>
        <ArrowsPointingOutIcon className="size-4" />
      </button>
      {!!preview && createPortal(<EditorPreview html={preview} onClose={handleClosePreview} />, document.body)}
    </div>
  );
};

export default React.memo(ProjectURL);
